import { render, staticRenderFns } from "./CopyUrlButton.vue?vue&type=template&id=0fe5aa42&"
import script from "./CopyUrlButton.vue?vue&type=script&lang=js&"
export * from "./CopyUrlButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports